/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { TeamUser } from '@src/app/model/team-user';

@Injectable({
    providedIn: 'root'
})
export class TeamUserService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);


    protected get baseUrl() {
        return this.getAjaxPath('tusers');
    }
    protected cache: TeamUser[];
    protected typeString = 'TeamUser';
}
